export class PeopleManagersHistoryDetails {

  ID: number;
  EmpCode: number;
  ManagerCode: number;
  ManagerDesignationID: number;
  DesignationName: string;
  DurationFrom: Date;
  DurationTo: Date;
  CreatedBy: string;
  CreatedDate: Date;
  UpdatedBy: string;
  UpdatedDate: Date;
  IsActive: boolean;
  //Added to display peoplemanger name along with code
  pmDisplayName: string;
  //to display error message for duplicate records in history tab
  hasDuplicateNameError?: boolean;
  duplicateNameMessage?: string;
  InvalidName?:boolean
}
